<template>
  <div>
    <b-modal
      id="promo-code-groups"
      title="Groups"
      ok-only
      @show="showHandler"
    >
      <v-select
        id="groups"
        v-model="selectedGroups"
        placeholder="Search groups by name"
        class="mb-1"
        :options="groupsList"
        label="name"
        :reduce="val => val.id"
        @input="selectNewGroup"
        @search="fetchGroups"
      />
      <b-badge
        v-for="g in localGroupsSelected"
        :key="g"
        class="mr-1"
        variant="primary"
      >
        <span class="mr-1">{{ g }}</span>
        <span
          style="cursor:pointer"
          @click="removeGroup(g)"
        >x</span>
      </b-badge>
    </b-modal>
  </div>
</template>

<script>

import {
  BModal, BBadge,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { debounce } from 'lodash'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import groupsStore from '@/views/marketing/groups/store'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal, vSelect, BBadge,
  },
  props: {
    selectedGroup: {
      type: Array,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    useRegisterStoreModule('groups', groupsStore)

    const selectedGroups = ref(null)
    const groupsList = ref([])
    const fetchGroups = debounce(async (search, loading) => {
      if (!search) return
      loading(true)

      const result = await axiosIns.get('/groups', {
        params: {
          name: search,
        },
      })
      const { data } = result.data.data
      groupsList.value = data
      loading(false)
    }, 1000)

    const localGroupsSelected = ref([])
    const selectNewGroup = grp => {
      localGroupsSelected.value.push(grp)
      selectedGroups.value = null
      groupsList.value = []
      emit('groups-selection', localGroupsSelected.value)
    }

    const removeGroup = grp => {
      const ix = localGroupsSelected.value.findIndex(g => g === grp)
      localGroupsSelected.value.splice(ix, 1)
      emit('groups-selection', localGroupsSelected.value)
    }

    const showHandler = () => {
      if (props.selectedGroup) {
        localGroupsSelected.value = props.selectedGroup
      }
    }
    return {
      selectedGroups,
      selectNewGroup,
      showHandler,
      fetchGroups,
      groupsList,
      localGroupsSelected,
      removeGroup,
    }
  },
}
</script>
